import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAppSelector } from '../../../Redux/hooks';
import { useTranslation } from '../../../i18n/useTranslation';
import type { PremiumFeature } from '../../../Models/enums';
import { routes } from '../../../Utils/routes';
import './PremiumGate.css';

/**
 * What a tutor without the subscription sees in place of a premium screen.
 *
 * It is a courtesy, not a lock. The server refuses the call on its own, so
 * this component being wrong shows the wrong screen rather than handing
 * anything over.
 */
export function PremiumGate({ feature, children }: { feature: PremiumFeature; children: ReactNode }) {
  const { tr } = useTranslation();
  const subscription = useAppSelector(state => state.session.subscription);
  const allowed = subscription?.features.some(
    entitlement => entitlement.key === feature && entitlement.accessible
  ) ?? false;

  if (allowed) return <>{children}</>;

  return (
    <section className="premium-gate">
      <h1 className="screen-title">{tr('premiumTitle')}</h1>
      <p className="premium-gate-lead">{tr('premiumLocked')}</p>
      <Link className="primary-button" to={routes.premiumArea}>{tr('premiumUpgrade')}</Link>
    </section>
  );
}
